/* eslint-disable comma-dangle */
export default {
  methods: {
    /**
     * Funcion encargada de modificar el scroll automaticamente
     * @param {string} idComponente componente que medira el scroll 
     * @param {string} componenteConScroll componente que tiene el atrubuto o clase scrollbar
     * @param {number} valorRestar valor a restar cuando el escroll se hace muy grande 
     */
    autoScroll(idComponente, componenteConScroll, valorRestar) {
      const alturaComponente = document.getElementById(idComponente).offsetTop;
      const scrollComponente = document.getElementsByClassName(componenteConScroll);
      scrollComponente[0].scrollTop = alturaComponente - valorRestar;
    }
  }
};



// WEBPACK FOOTER //
// ./src/js/mixins/mixinScroll.js